import { gql } from '@apollo/client';

export const UPDATE_PRINT_PROVIDER = gql`
  mutation updateProvider($printProviderId: String!, $body: Body!) {
    putProvider: publish(printProviderId: $printProviderId, body: $body)
      @rest(
        type: "Update Print Provider"
        path: "printprovider/{args.printProviderId}"
        method: "PUT"
        bodyKey: "body"
      ) {
      printProviderId
      name
      isEnabled
      isOrgIdRequired
      description
      country
      language
      address
      phoneNumber
      email
      emailForOrders
      website
      omsType
      omsServiceUrl
      omsSecretKey
      deliveryOptions
      orderingSystems
      omsUsers
      documentPrintSettings {
        defaultPrintOption
        printOptions
        defaultPostProcessingOption
        postProcessingOptions
      }
      drawingPrintSettings {
        defaultFormatGroup
        formatGroups
        defaultPrintOption
        printOptions
        defaultPostProcessingOption
        postProcessingOptions
      }
    }
  }
`;
